import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

const Link = ({ children, url, anchorLink, onMenuClick }) => {
  const anchorHash = !!anchorLink ? `#${anchorLink}` : '';
  const fullUrl = `${url.url}${anchorHash}`;

  if (url.link_type === 'Document') {
    // Use regular <a> tag for event pages to trigger full page reload
    const isEventPage = url.url.includes('/event/');

    if (isEventPage) {
      return (
        <a href={fullUrl} className="link-tag" onClick={onMenuClick}>
          {children}
        </a>
      );
    }

    return (
      <GatsbyLink
        to={fullUrl}
        activeClassName="is-active"
        className="link-tag"
        onClick={onMenuClick}
      >
        {children}
      </GatsbyLink>
    );
  }

  return (
    <a href={url.url} target="_blank" rel="noreferrer" className="link-tag">
      {children}
    </a>
  );
};

export default Link;
